import { reservationRoom, contactReservationResonse, reservationResponse } from '../../../model/reservation';
import { SelectItem } from '../../../ui-components/select/Select';
export interface IState {
    roomList: SelectItem[];
    roomSelected?: SelectItem;
    viewType: "day" | "week";
    reservationRooms: reservationRoom[];
    dayView: Date;
    reservations: contactReservationResonse[];
    reservationResponse?: reservationResponse;
    areLoadingReservationRooms: boolean;
    addingReservation: boolean;
    deletingReservation: boolean;
    loadingReservations: boolean;
}

export const DefaultState = (): IState => ({
    reservations: [],
    loadingReservations: false,
    addingReservation: false,
    deletingReservation: false,
    reservationRooms: undefined,
    roomSelected: undefined,
    dayView: new Date(),
    roomList: [],
    reservationResponse: undefined,
    viewType: "day",
    areLoadingReservationRooms: false,
})